import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { getModel } from '../PowertrainOverview/selectors';
import { triggerReportIssueDialog, hideReportIssueModal } from '../PowertrainOverview/actions';

// eslint-disable-next-line import/no-unused-modules
export const useReportIssue = () => {
    const dispatch = useDispatch();

    const {
        reportIssueVisibility,
        reportIssueModalType,
        reportIssueModalMetadata
    } = useSelector(getModel);

    const showReportIssue = useCallback((additionalData = {}) => {
        dispatch(triggerReportIssueDialog(additionalData));
    }, [dispatch]);

    const hideReportIssue = useCallback(() => {
        dispatch(hideReportIssueModal());
    }, [dispatch]);


    return {
        reportIssueVisibility,
        reportIssueModalType,
        reportIssueModalMetadata,
        showReportIssue,
        hideReportIssue,
    };
};
